import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {MenuItem, Typography, BaseSelectProps} from '@mui/material'
import {CommonProps} from '@mui/material/OverridableComponent'
import {theme} from '@styles'

import React, {ReactNode, useMemo} from 'react'

import {LabeledWrapper} from '../wrapper-with-label'
import {MenuItemContent, StyledSelect, iconStyle} from './style'

export type DropdownItem = {
  value: string | number
  label: string
  icon?: ReactNode
}

export interface DropdownProps {
  items: DropdownItem[]
  renderValue?: () => JSX.Element
  customStyle?: CommonProps['style']
  label?: string
  value?: string | number
  hideBorder?: boolean
  width?: number
  tooltip?: string
}

/**
 * Dropdown component
 */
export function Dropdown(props: DropdownProps & BaseSelectProps) {
  const {label, hideBorder, width, items, renderValue, error, value, disabled, tooltip, ...rest} = props

  const defaultRenderValue = () => {
    return (
      <Typography textAlign={'start'} color={!value ? theme.palette.grey[200] : 'initial'} variant="body2">
        {!value ? label : items.find(item => item.value === value)?.label}
      </Typography>
    )
  }

  const safeValue = useMemo(() => (items.some(i => i.value === value) ? value : ''), [items, value])

  return (
    <LabeledWrapper width={width} label={label} tooltip={tooltip}>
      <StyledSelect
        IconComponent={() =>
          error ? (
            <ErrorOutlineRoundedIcon style={{color: theme.palette.error.main, paddingRight: 15}} />
          ) : disabled ? (
            <></>
          ) : (
            <ExpandMoreIcon style={iconStyle} />
          )
        }
        hideBorder={hideBorder}
        displayEmpty
        disabled={disabled}
        value={safeValue}
        renderValue={renderValue ?? defaultRenderValue}
        {...rest}
      >
        {items?.map((item, index) => {
          const {value, label: itemLabel, icon} = item
          return (
            <MenuItem key={`${label}-dropdown-item-${index}`} value={value}>
              <MenuItemContent>
                {itemLabel}
                {icon}
              </MenuItemContent>
            </MenuItem>
          )
        })}
      </StyledSelect>
    </LabeledWrapper>
  )
}
